export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  date: string;
  image: string;
  imageAlt: string;
  author: string;
  tags: string[];
  featured: boolean;
  readTime: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '作品', slug: 'works' },
  { name: '寫真', slug: 'photobooks' },
  { name: '最新消息', slug: 'news' },
  { name: '個人資料', slug: 'profile' },
  { name: '粉絲專區', slug: 'fan-zone' },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'yua-mikami-your-angel-photobook-release',
    title: '三上悠亞最新寫真集《Your Angel》正式發售',
    excerpt: '三上悠亞睽違兩年的全新寫真集《Your Angel》已於本月正式發售，本次寫真遠赴沖繩取景，收錄超過200張精美照片，展現三上悠亞前所未有的成熟魅力與清新氣質。',
    content: `<p>日本知名寫真偶像三上悠亞，睽違兩年推出全新個人寫真集《Your Angel》，已於本月在日本及海外同步發售，引發粉絲熱烈搶購。</p>
<h2>沖繩取景：陽光與海洋交織的夢幻畫面</h2>
<p>本次寫真集特別遠赴日本沖繩進行為期一週的拍攝，從碧藍海灘到靜謐森林，從傳統民宿到現代度假村，三上悠亞以多達三十套不同風格的造型，展現了她從清新甜美到成熟嫵媚的多面向魅力。攝影師特別捕捉了日出與日落時分的自然光影，讓每張照片都充滿電影般的質感。</p>
<p>三上悠亞在受訪時表示：「這次的寫真集是我出道以來最滿意的作品之一。沖繩的自然美景給了我很多靈感，我希望粉絲們能透過這些照片，感受到我和大自然融為一體的那種純粹與自由。」</p>
<h2>超過200頁的視覺饗宴</h2>
<p>《Your Angel》全書共計208頁，收錄超過200張精選照片，並附有長達16頁的三上悠亞親筆訪談，內容涵蓋她對演藝事業的展望、生活中的小確幸，以及對粉絲多年支持的感謝之詞。</p>
<p>寫真集分為普通版與珍藏版兩種版本。珍藏版除了包含普通版全部內容外，還附加限量版海報、簽名小卡及特別拍攝的幕後花絮DVD，是粉絲不可錯過的收藏逸品。</p>
<h2>發售資訊</h2>
<p>《Your Angel》普通版定價為3,200日圓（約新台幣780元），珍藏版定價為6,800日圓（約新台幣1,650元）。目前已於各大網路書店及實體通路全面上架，部分通路更推出限量預購特典，數量有限，售完為止。</p>
<blockquote>「每一張照片都是我和團隊用心打造的作品，希望大家會喜歡。」——三上悠亞</blockquote>`,
    category: '寫真',
    categorySlug: 'photobooks',
    date: '2024-06-15',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20soft%20warm%20lighting%20with%20subtle%20cherry%20blossom%20petals%20floating%20gently%2C%20dreamy%20romantic%20atmosphere%2C%20minimalist%20Japanese%20aesthetic%2C%20blurred%20bokeh%20background%20with%20soft%20rose%20and%20cream%20tones%2C%20editorial%20photography%20style%2C%20sophisticated%20and%20refined%20composition%20with%20golden%20accents&width=800&height=500&seq=article-1&orientation=landscape',
    imageAlt: '三上悠亞最新寫真集《Your Angel》封面',
    author: '編輯部',
    tags: ['寫真集', 'Your Angel', '沖繩', '三上悠亞'],
    featured: true,
    readTime: '5 分鐘',
  },
  {
    id: '2',
    slug: 'yua-mikami-2024-special-project-review',
    title: '三上悠亞2024年特別企劃作品回顧',
    excerpt: '2024年對三上悠亞而言是充滿突破的一年。從年初的劇情長片到年中的特別企劃，三上悠亞以精湛演技與敬業態度，為粉絲帶來了多部令人印象深刻的精彩作品。',
    content: `<p>2024年對三上悠亞而言，無疑是演藝生涯中極具里程碑意義的一年。從年初到年中，她接連推出了多部備受好評的作品，無論是在演技深度還是角色詮釋上，都展現了顯著的成長與突破。</p>
<h2>年度代表作品</h2>
<p>今年推出的作品涵蓋了多元化的題材，從浪漫愛情到懸疑驚悚，三上悠亞以細膩的表演征服了觀眾與影評人。她表示：「每一個角色都是一次全新的挑戰，我希望能不斷突破自己，帶給觀眾更多驚喜。」</p>
<h2>演技突破獲好評</h2>
<p>多位資深影評人指出，三上悠亞在2024年的作品中展現了更加成熟與多層次的情感表達，特別是在內心戲的處理上，細微的表情變化與眼神傳達，讓人感受到她作為演員的深度與潛力。</p>
<h2>粉絲支持度持續攀升</h2>
<p>根據各大影音平台的數據顯示，三上悠亞2024年作品的觀看次數較去年成長了35%以上，粉絲社群活躍度也屢創新高，足見其持續飆升的人氣與影響力。</p>`,
    category: '作品',
    categorySlug: 'works',
    date: '2024-05-28',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20elegant%20art%20deco%20interior%20with%20velvet%20textures%2C%20vintage%20film%20aesthetic%2C%20sophisticated%20mood%2C%20rich%20golden%20and%20cream%20color%20palette%2C%20editorial%20quality%20composition&width=800&height=500&seq=article-2&orientation=landscape',
    imageAlt: '三上悠亞2024年作品回顧',
    author: '編輯部',
    tags: ['2024作品', '企劃', '演技', '三上悠亞'],
    featured: true,
    readTime: '4 分鐘',
  },
  {
    id: '3',
    slug: 'yua-mikami-biography-from-ske48-to-star',
    title: '三上悠亞個人檔案：從SKE48到國民女優的傳奇之路',
    excerpt: '三上悠亞，1993年8月16日出生於日本愛知縣名古屋市，從偶像團體SKE48出身，歷經轉型成為日本最具代表性的寫真偶像與女演員之一，這段傳奇旅程令人驚嘆。',
    content: `<p>三上悠亞（日語：三上悠亜／みかみ ゆあ），1993年8月16日出生於日本愛知縣名古屋市，是日本知名的寫真偶像、女演員及前偶像團體成員。她的演藝之路充滿傳奇色彩，從偶像團體到個人發展，每一步都備受矚目。</p>
<h2>基本資料</h2>
<p>本名：三上悠亞<br/>出生日期：1993年8月16日<br/>出生地：日本愛知縣名古屋市<br/>血型：A型<br/>身高：159cm<br/>三圍：84 - 58 - 85 cm<br/>興趣：看電影、美容、旅行<br/>專長：舞蹈、游泳</p>
<h2>SKE48時期：偶像之路的起點</h2>
<p>三上悠亞的演藝生涯始於2009年，當時年僅16歲的她通過SKE48第二期生甄選，正式成為偶像團體的一員。在SKE48期間，她以甜美外型與認真態度獲得了一定的人氣基礎，也曾參與多首單曲的錄製與舞台演出。</p>
<p>然而，偶像團體的生活並非一帆風順。在競爭激烈的環境中，三上悠亞始終未能進入團體的核心選拔名單。2014年，她做出了人生中最重要的決定之一：從SKE48畢業，踏上全新的演藝道路。</p>
<h2>轉型之路：從偶像到寫真女星</h2>
<p>離開SKE48後，三上悠亞以全新的形象重新出發。憑藉出色的外型條件與過人的努力，她迅速在寫真界嶄露頭角，成為各大雜誌爭相邀請的封面人物。她的寫真作品風格多變，從清新甜美到性感成熟，展現了極強的可塑性與表現力。</p>
<h2>演藝成就</h2>
<p>經過多年的努力耕耘，三上悠亞已成為日本演藝圈最具知名度的女星之一。她在社交媒體上擁有超過數百萬的追隨者，每部作品都受到粉絲的高度期待與熱烈討論。她曾多次獲得業界重要獎項，並持續在演藝事業上追求突破與創新。</p>`,
    category: '個人資料',
    categorySlug: 'profile',
    date: '2024-04-10',
    image: 'https://readdy.ai/api/search-image?query=Soft%20golden%20hour%20lighting%20in%20a%20minimalist%20Japanese%20room%20with%20tatami%20mats%20and%20shoji%20screens%2C%20elegant%20serene%20atmosphere%2C%20warm%20cream%20and%20beige%20tones%2C%20traditional%20meets%20modern%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-3&orientation=landscape',
    imageAlt: '三上悠亞個人資料與出道歷程',
    author: '編輯部',
    tags: ['個人資料', 'SKE48', '出道歷程', '三上悠亞'],
    featured: true,
    readTime: '6 分鐘',
  },
  {
    id: '4',
    slug: 'yua-mikami-new-film-hana-to-hebi',
    title: '三上悠亞宣布參與新電影《花與蛇》演出',
    excerpt: '三上悠亞正式宣布將參與日本知名電影系列《花與蛇》最新作的演出，這是她首次挑戰大銀幕劇情長片，引發影迷與粉絲的高度期待。',
    content: `<p>日本知名女星三上悠亞於今日透過官方社群媒體正式宣布，她將參與日本經典電影系列《花與蛇》最新作的演出。這不僅是三上悠亞首次挑戰大銀幕劇情長片，更象徵著她演藝事業的全新里程碑。</p>
<h2>挑戰全新領域</h2>
<p>《花與蛇》系列在日本電影史上具有特殊地位，以細膩的藝術表現與複雜的人物心理描寫聞名。三上悠亞在片中飾演一位充滿神秘感的女性角色，這與她過往的螢幕形象截然不同，對她的演技而言是一大挑戰。</p>
<h2>導演盛讚</h2>
<p>該片導演在記者會上表示：「三上悠亞的試鏡表現令我驚豔，她對角色的理解深入且獨特，我相信她將帶給觀眾一個令人難忘的演出。」三上悠亞本人則謙虛地表示，會全力以赴準備這個角色，不辜負大家的期待。</p>
<h2>上映資訊</h2>
<p>《花與蛇》最新作預計於2025年春季在日本全國上映，目前已進入緊鑼密鼓的拍攝階段。粉絲們對於三上悠亞的大銀幕處女作充滿期待，相關討論在社交媒體上持續升溫。</p>`,
    category: '最新消息',
    categorySlug: 'news',
    date: '2024-06-01',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20set%20atmosphere%20with%20dramatic%20warm%20lighting%2C%20vintage%20film%20camera%20and%20director%20chair%2C%20soft%20focus%20background%20with%20golden%20and%20rose%20tones%2C%20artistic%20composition%2C%20sophisticated%20film%20noir%20aesthetic&width=800&height=500&seq=article-4&orientation=landscape',
    imageAlt: '三上悠亞新電影《花與蛇》演出消息',
    author: '編輯部',
    tags: ['花與蛇', '電影', '新作品', '三上悠亞'],
    featured: false,
    readTime: '3 分鐘',
  },
  {
    id: '5',
    slug: 'yua-mikami-fan-meeting-tokyo-2024',
    title: '粉絲見面會東京場：三上悠亞與粉絲零距離互動',
    excerpt: '三上悠亞於東京舉辦的年度粉絲見面會圓滿落幕，現場超過千名粉絲共襄盛舉。活動中不僅有精采的互動遊戲，三上悠亞更親自為每位幸運粉絲簽名合影。',
    content: `<p>三上悠亞年度粉絲見面會東京場於上週末在澀谷盛大舉行，吸引了來自日本各地及海外的超過千名粉絲到場參與，現場氣氛熱烈溫馨。</p>
<h2>精心策劃的互動環節</h2>
<p>本次見面會由三上悠亞親自參與策劃，設計了多個別出心裁的互動遊戲。從問答環節到才藝表演，三上悠亞展現了親切幽默的一面，與粉絲們度過了一段難忘的時光。</p>
<h2>粉絲心聲</h2>
<p>現場多位粉絲表示，三上悠亞本人比螢幕上更加親切可愛，完全沒有明星架子。一位來自台灣的粉絲說：「專程飛來東京參加這場見面會真的非常值得，三上悠亞的親和力讓我印象非常深刻。」</p>
<h2>限定周邊商品</h2>
<p>活動現場也推出了多款限定周邊商品，包括簽名海報、限定版寫真小卡及官方應援毛巾等，所有商品在開場後不到一小時即銷售一空，足見三上悠亞的超高人氣。</p>`,
    category: '粉絲專區',
    categorySlug: 'fan-zone',
    date: '2024-05-20',
    image: 'https://readdy.ai/api/search-image?query=Warm%20event%20venue%20with%20soft%20stage%20lighting%20in%20rose%20and%20golden%20hues%2C%20elegant%20decorated%20hall%20with%20floral%20arrangements%2C%20dreamy%20atmosphere%2C%20sophisticated%20event%20photography%20style%2C%20cream%20and%20blush%20color%20palette&width=800&height=500&seq=article-5&orientation=landscape',
    imageAlt: '三上悠亞東京粉絲見面會',
    author: '編輯部',
    tags: ['粉絲見面會', '東京', '互動', '三上悠亞'],
    featured: true,
    readTime: '4 分鐘',
  },
  {
    id: '6',
    slug: 'yua-mikami-photo-exhibition-osaka',
    title: '三上悠亞寫真展《夢幻時刻》大阪開展',
    excerpt: '三上悠亞個人寫真展《夢幻時刻》於大阪心齋橋正式開幕，展出超過50幅從未公開過的珍藏照片，展期為期兩週，吸引大批粉絲排隊等候入場。',
    content: `<p>三上悠亞個人寫真展《夢幻時刻》已於大阪心齋橋的當代藝術空間正式開幕。本次展覽匯集了超過50幅三上悠亞歷年來的精選寫真作品，其中包含多幅從未公開過的珍藏照片，為粉絲呈現一場豐富的視覺盛宴。</p>
<h2>展覽亮點</h2>
<p>展覽以「夢幻時刻」為主題，透過不同的光影與場景設計，帶領觀眾走進三上悠亞的多元面向。展場特別規劃了「晨曦」、「午後」、「黃昏」、「午夜」四個主題區域，每個區域都展現了三上悠亞在不同時間與氛圍下的獨特魅力。</p>
<h2>粉絲反應熱烈</h2>
<p>開幕首日即吸引了大批粉絲排隊等候入場，現場更有多位幸運粉絲獲得了三上悠亞親筆簽名的展覽限定海報。許多粉絲表示，能夠近距離欣賞到這些精心挑選的寫真作品，是一種非常特別的體驗。</p>`,
    category: '最新消息',
    categorySlug: 'news',
    date: '2024-05-10',
    image: 'https://readdy.ai/api/search-image?query=Art%20gallery%20exhibition%20space%20with%20warm%20soft%20lighting%2C%20minimalist%20white%20walls%20with%20framed%20artworks%2C%20elegant%20interior%20design%2C%20sophisticated%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20contemporary%20Japanese%20aesthetic&width=800&height=500&seq=article-6&orientation=landscape',
    imageAlt: '三上悠亞寫真展《夢幻時刻》大阪展場',
    author: '編輯部',
    tags: ['寫真展', '大阪', '夢幻時刻', '三上悠亞'],
    featured: false,
    readTime: '3 分鐘',
  },
  {
    id: '7',
    slug: 'yua-mikami-2023-awards',
    title: '三上悠亞2023年度作品大賞獲獎名單',
    excerpt: '三上悠亞在2023年度多個重要獎項中斬獲佳績，包括最佳女主角、最受歡迎女星及年度最佳作品等多項大獎，實力與人氣雙雙獲得肯定。',
    content: `<p>2023年度各大演藝獎項陸續揭曉，三上悠亞憑藉出色的表現與高人氣，在眾多競爭對手中脫穎而出，斬獲了多項重要獎項，為她的演藝生涯再添輝煌一頁。</p>
<h2>獲獎項目</h2>
<p>三上悠亞在2023年度共獲得包括「最佳女主角獎」、「最受歡迎女星獎」、「年度最佳作品獎」及「粉絲票選人氣獎」在內的多項殊榮。這些獎項不僅肯定了她在演藝領域的專業表現，也反映了她在粉絲心中無可取代的地位。</p>
<h2>感言</h2>
<p>在頒獎典禮上，三上悠亞感性表示：「每一座獎盃都是對我的鼓勵與肯定，謝謝所有支持我的粉絲、工作夥伴以及家人。沒有你們，就沒有今天的我。」</p>`,
    category: '作品',
    categorySlug: 'works',
    date: '2024-03-22',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20warm%20golden%20spotlights%2C%20trophy%20on%20pedestal%2C%20luxurious%20red%20and%20gold%20decor%2C%20sophisticated%20gala%20atmosphere%2C%20soft%20bokeh%20background%2C%20prestigious%20event%20photography&width=800&height=500&seq=article-7&orientation=landscape',
    imageAlt: '三上悠亞2023年度獲獎榮譽',
    author: '編輯部',
    tags: ['獲獎', '2023', '最佳女主角', '三上悠亞'],
    featured: false,
    readTime: '3 分鐘',
  },
  {
    id: '8',
    slug: 'yua-mikami-photobook-mikami-behind-scenes',
    title: '三上悠亞寫真集《Mikami》幕後花絮公開',
    excerpt: '三上悠亞寫真集《Mikami》的幕後拍攝花絮獨家公開！從清晨四點的化妝準備到深夜的收工時刻，帶你窺見鏡頭背後的真實三上悠亞。',
    content: `<p>三上悠亞上一本寫真集《Mikami》自發售以來廣受好評，而今天官方特別公開了拍攝期間的幕後花絮，讓粉絲們得以一窺鏡頭背後的真實樣貌。</p>
<h2>從清晨到深夜的拍攝日常</h2>
<p>幕後花絮記錄了拍攝團隊從清晨四點開始準備、化妝、造型，到深夜收工的完整過程。影片中的三上悠亞沒有螢幕前的完美形象，展現了自然隨性的一面：在休息時間吃便當、和工作人員開玩笑、在拍攝空檔小憩片刻——這些真實的瞬間讓粉絲們直呼「太可愛了」。</p>
<h2>團隊合作的溫暖</h2>
<p>花絮中也記錄了整個拍攝團隊的互動，從攝影師到造型師，從燈光師到後製團隊，每一個人都在為打造最好的作品而努力。三上悠亞在花絮尾聲感性地感謝了每一位工作夥伴，展現了她溫暖真誠的一面。</p>`,
    category: '寫真',
    categorySlug: 'photobooks',
    date: '2024-03-05',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photography%20studio%20with%20warm%20soft%20lighting%2C%20professional%20camera%20equipment%2C%20elegant%20dressing%20room%20with%20mirrors%20and%20vanity%20lights%2C%20cozy%20atmosphere%2C%20cream%20and%20rose%20tones%2C%20editorial%20documentary%20style&width=800&height=500&seq=article-8&orientation=landscape',
    imageAlt: '三上悠亞寫真集《Mikami》幕後花絮',
    author: '編輯部',
    tags: ['寫真集', 'Mikami', '幕後花絮', '三上悠亞'],
    featured: false,
    readTime: '4 分鐘',
  },
  {
    id: '9',
    slug: 'yua-mikami-birthday-fan-event',
    title: '三上悠亞生日特別企劃：粉絲應援活動全記錄',
    excerpt: '三上悠亞31歲生日當天，來自全球各地的粉絲以各種創意方式為她慶生，從地鐵廣告到社群串聯，滿滿的應援讓三上悠亞感動落淚。',
    content: `<p>8月16日是三上悠亞的生日，今年的31歲生日對她來說格外特別。來自全球各地的粉絲們精心策劃了一系列應援活動，以最具創意的方式為心愛的偶像獻上祝福。</p>
<h2>全球粉絲應援活動</h2>
<p>今年粉絲們的應援活動規模空前：東京澀谷的大型戶外廣告看板、台北捷運的車廂廣告、首爾的咖啡廳應援活動，以及遍及全球的社群媒體串聯，都見證了三上悠亞跨國界的超高人氣。</p>
<h2>三上悠亞的驚喜與感動</h2>
<p>三上悠亞在生日當天透過直播與粉絲互動，當她看到來自世界各地的應援照片和影片時，感動得數度哽咽。她表示：「每一年的生日都因為有大家的陪伴而變得特別，我真的非常幸福。謝謝大家一直以來的支持與愛護，我會繼續努力，不辜負大家的期待。」</p>`,
    category: '粉絲專區',
    categorySlug: 'fan-zone',
    date: '2024-08-16',
    image: 'https://readdy.ai/api/search-image?query=Birthday%20celebration%20decor%20with%20warm%20festive%20lighting%2C%20elegant%20floral%20arrangements%20in%20rose%20and%20cream%20tones%2C%20balloons%20and%20celebration%20atmosphere%2C%20soft%20golden%20bokeh%2C%20sophisticated%20party%20photography%20style&width=800&height=500&seq=article-9&orientation=landscape',
    imageAlt: '三上悠亞生日粉絲應援活動',
    author: '編輯部',
    tags: ['生日', '粉絲應援', '8月16日', '三上悠亞'],
    featured: true,
    readTime: '4 分鐘',
  },
  {
    id: '10',
    slug: 'yua-mikami-10th-anniversary-interview',
    title: '三上悠亞出道十週年紀念專訪',
    excerpt: '三上悠亞迎來出道十週年，在這次獨家專訪中，她回顧十年來的點點滴滴，分享心路歷程、演藝生涯的轉捩點，以及對未來的展望。',
    content: `<p>今年是三上悠亞出道的第十個年頭，從一名青澀的偶像團體成員到如今的國民級女星，這十年的旅程充滿了挑戰、成長與蛻變。在這個特別的時刻，我們與三上悠亞進行了一次深度專訪，聽她親口回顧這段不平凡的歲月。</p>
<h2>回顧十年：從迷惘到堅定</h2>
<p>「十年前的我，完全沒有想過自己能走到今天這一步。」三上悠亞坦言，剛出道時的她曾面臨許多不確定與自我懷疑。「特別是在SKE48畢業後的那段時間，我真的不知道自己的未來在哪裡。但我告訴自己，既然選擇了這條路，就要全力以赴。」</p>
<h2>轉捩點</h2>
<p>談到演藝生涯的轉捩點，三上悠亞認為是學會「做自己」的那一刻。「以前的我總是試著去迎合別人的期待，但後來我發現，真正的魅力來自於做最真實的自己。當我不再害怕展現真實的一面之後，一切反而變得更加順利。」</p>
<h2>未來展望</h2>
<p>對於下一個十年，三上悠亞充滿期待。「我希望能夠挑戰更多不同類型的角色和工作，也希望能有機會參與更多的國際合作。最重要的是，我希望能一直保持對這份工作的熱情和初心。」</p>`,
    category: '個人資料',
    categorySlug: 'profile',
    date: '2024-02-14',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20studio%20setting%20with%20warm%20diffused%20lighting%2C%20soft%20cream%20backdrop%2C%20refined%20and%20sophisticated%20mood%2C%20editorial%20interview%20photography%20style%2C%20gentle%20golden%20and%20beige%20tones&width=800&height=500&seq=article-10&orientation=landscape',
    imageAlt: '三上悠亞出道十週年專訪',
    author: '編輯部',
    tags: ['十週年', '專訪', '心路歷程', '三上悠亞'],
    featured: true,
    readTime: '7 分鐘',
  },
  {
    id: '11',
    slug: 'yua-mikami-new-work-peach-announcement',
    title: '三上悠亞最新作品《蜜桃成熟時》即將上線',
    excerpt: '三上悠亞最新作品《蜜桃成熟時》即將於下月正式上線。本作以夏日為背景，融合了浪漫與青春的元素，是三上悠亞今年最受期待的作品之一。',
    content: `<p>三上悠亞最新作品《蜜桃成熟時》日前已完成全部拍攝工作，預計於下月正式上線各大平台。本作以夏日為背景，講述了一段甜美而動人的青春故事，被譽為三上悠亞今年最具代表性的作品之一。</p>
<h2>故事概要</h2>
<p>《蜜桃成熟時》以日本某個沿海小鎮為舞台，三上悠亞在劇中飾演一位返鄉的青年女性，在夏日的海風與陽光中，重新找回了對生活與愛情的悸動。全片散發著濃厚的夏日情懷與青春氣息，畫面唯美，情感細膩動人。</p>
<h2>製作團隊</h2>
<p>本作由日本知名導演掌鏡，並邀請到多位實力派演員共同演出。製作團隊在場景選擇上特別用心，遠赴日本各地取景，力求呈現最完美的視覺效果。三上悠亞表示：「這是我投入最多情感的一部作品，希望大家能感受到其中的溫暖與感動。」</p>`,
    category: '作品',
    categorySlug: 'works',
    date: '2024-07-01',
    image: 'https://readdy.ai/api/search-image?query=Summer%20coastal%20scenery%20with%20soft%20sunset%20lighting%2C%20gentle%20ocean%20waves%2C%20warm%20golden%20and%20peach%20tones%2C%20romantic%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20Japanese%20seaside%20town%20aesthetic&width=800&height=500&seq=article-11&orientation=landscape',
    imageAlt: '三上悠亞最新作品《蜜桃成熟時》',
    author: '編輯部',
    tags: ['蜜桃成熟時', '新作品', '夏日', '三上悠亞'],
    featured: false,
    readTime: '3 分鐘',
  },
  {
    id: '12',
    slug: 'yua-mikami-fan-club-exclusive-benefits',
    title: '三上悠亞粉絲俱樂部會員限定福利公開',
    excerpt: '三上悠亞官方粉絲俱樂部推出全新會員限定福利，包括獨家直播、限定周邊商品、優先購票權及專屬生日驚喜等多項超值內容。',
    content: `<p>三上悠亞官方粉絲俱樂部宣布推出全新會員限定福利方案，為忠實粉絲帶來更多獨家內容與專屬權益。新方案涵蓋了從線上到線下的全方位粉絲體驗，讓會員們能夠更近距離地感受三上悠亞的魅力。</p>
<h2>會員限定福利內容</h2>
<p>新方案包含多項令人心動的福利：每月一次的會員限定直播，三上悠亞將親自與會員互動交流；季度限定周邊商品，僅會員可購買；演唱會及見面會的優先購票權；會員專屬的生日驚喜禮包；以及不定期舉辦的會員限定線上活動。</p>
<h2>如何加入</h2>
<p>粉絲俱樂部提供月費制與年費制兩種方案，年費制方案可享有多項額外優惠。有興趣的粉絲可至官方網站查詢詳細資訊並完成線上註冊。</p>`,
    category: '粉絲專區',
    categorySlug: 'fan-zone',
    date: '2024-07-10',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20membership%20club%20aesthetic%20with%20warm%20golden%20and%20cream%20tones%2C%20elegant%20VIP%20lounge%20interior%2C%20velvet%20textures%2C%20soft%20ambient%20lighting%2C%20sophisticated%20exclusive%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=article-12&orientation=landscape',
    imageAlt: '三上悠亞粉絲俱樂部限定福利',
    author: '編輯部',
    tags: ['粉絲俱樂部', '會員福利', '限定', '三上悠亞'],
    featured: false,
    readTime: '3 分鐘',
  },
];